// @ts-nocheck
/* eslint-disable no-invalid-this */
/**
 * @class Položka kontextového menu na přidání vlastního bodu
 */
export function getContextMenu(labelArg, scope) {
	function ContextItem(label, owner) {
		SMap.Control.ContextMenu.Item.call(this, label);
		this._owner = owner;
	}

	ContextItem.prototype = Object.create({
		...SMap.Control.ContextMenu.Item.prototype,
	});

	ContextItem.prototype.click = function click(event, menu) {
		if (this._disabled) {
			return;
		}

		menu.close();

		if (!Mapy.getComponent("userMarks").isActive()) {
			Mapy.getComponent("userMarks").activate();
		}

		this._owner.addItem([this._coords.x, this._coords.y]);

		Mapy.getComponent("history").save();
	};

	return new ContextItem(labelArg, scope);
}
